export default __webpack_public_path__ + "static/media/nevoeiro.372f0b16.svg";